window.onload = () => {
    const asciiArt = [
    "                               ..:+*%                                                               ",
    "                            ..#%%%%%%                                                               ",
    "                           -%%%%%%%%%                                                               ",
    "                           .%%%%%%%%%*               .#%%%=                                         ",
    "                            .%%%%%%%%%.          .=%%%%%%%+                                         ",
    "                            .%%%%%%%%%:         .%%%%%%%%%*                                         ",
    "                             :%%%%%%%%%.         :%%%%%%%%%.                                        ",
    "                             :%%%%#+%%%*          +%%%%%%%%=                                        ",
    "                             :%%%%*.%%%%=         -%%%%%%%%#                                        ",
    "                            .%%%%%+ .%%%%+         %%%%%%%%%*                                       ",
    "                            .%%%%%   .%%%%*        %%%%%:%%%%.                                      ",
    "                  =%-..    .%%%%%=    .%%%%#.     .%%%%%.:%%%%.                                     ",
    "                 .%%%%%%#*+#%%%%*      .%%%%%.    =%%%%*  -%%%%.                                    ",
    "                 -%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*%%%%%:   -%%%%-                                   ",
    "                 =%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*=:-%%%%+                                  ",
    "                 -%%+:.*%%%%%%…..::::=*%%%%%%%%%%%%%%%%%%%%%%%%%%%*                                 ",
    "                     -%%%%%%%.              .%%%%%%%%*#%%%%%%%%%%%%%=:                              ",
    "                   :%%%%%%%#                 :%%%%%%.    .:=%%%%%%%%%%%%#*-.                        ",
    "                .-%%%%%%%%*                .%%%%%%%%.           .#%%%%%%%%%%%%%%%%.                ",
    "               =%%%%%%%%%=               .*%%%%%%%%%%:            =%%%%%%%%%%%%%%-                 ",
    "              -%%%%%%%%%-               +%%%%%%%%=%%%%.            :%%%%*.%%%%%%=                  ",
    "               +%%%%%%%:              =%%%%%%%%*  =%%%%-            .%%%%#.:%%%*.                  ",
    "                +%%%%%:            .#%%%%%%%%%-    *%%%%-            .%%%%%..++.                   ",
    "                 =%%%-             .#%%%%%%%%.     .%%%%%+             #%%%%.                      ",
    "                  :%#.              .%%%%%%%:       =%%%%%+             #%%%%.                     ",
    "                   .                  %%%%%-        :%%%%%%*            .%%%%%.                    ",
    "                                       #%%+         .%%%%%%%#           +%%%%%.                   ",
    "                                        +#           %%%%%%%%#           .%%%%%%:                  ",
    "                                                    .%%%%%%%%%#.          *%%%%%%:                 ",
    "                                                    .%%%%%%%%%%%.         =%%%%%%%-                ",
    "                                                    :%%%%%%#+.            =%%%%%%%%-               ",
    "                                                    %%%+:.                +%%%%%%%%%+              ",
    "                                                                          #%%%%%%%%%+.             ",
    "                                                                         .%%%%%#=.                 ",
    "                                                                         +#-..                     "
  ];

  let birdSpawned = false;
  const explosionSound = new Audio('https://cdn.shopify.com/s/files/1/0612/2602/5027/files/explo.mp3?v=1744885032');
  explosionSound.volume = 0.2;
  explosionSound.preload = 'auto';

  const lines = document.querySelectorAll(".terminal-line");
  let lineIndex = 0;

  function typeLine(lineEl, text, callback) {
    lineEl.textContent = "";
    lineEl.style.visibility = "visible";
    let charIndex = 0;
    const isLoadingDots = text.includes("loading assets");

    function typeChar() {
      if (charIndex < text.length && text.charAt(charIndex) !== '.') {
        lineEl.textContent += text.charAt(charIndex);
        charIndex++;
        setTimeout(typeChar, 30);
      } else if (isLoadingDots) {
        let dotCount = 0;
        const dotInterval = setInterval(() => {
          lineEl.textContent += '.';
          dotCount++;
          if (dotCount === 3) {
            clearInterval(dotInterval);
            if (callback) callback();
          }
        }, 300);
      } else if (callback) {
        callback();
      }
    }

    typeChar();
  }

  function showTerminalLines() {
  const hasSeenIntro = localStorage.getItem("hasSeenIntro");

  if (hasSeenIntro) {
    // Skip intro, go straight to ASCII phase
    clearTerminal(() => {
      typeAsciiArt(asciiArt, 'ascii-container', () => {
        const cmd = document.getElementById('command-line');
        const opts = document.getElementById('options-line');
        cmd.style.visibility = opts.style.visibility = "visible";
        cmd.classList.add('fade-in');
        opts.classList.add('fade-in');
        animateAscii('ascii-container');
        explodeAscii('ascii-container');
        setTimeout(showBlogPopupIfRecent, 3000);
      });
    });
    return;
  }

  // Run full intro and set the flag
  localStorage.setItem("hasSeenIntro", "true");

  // ✅ FIXED ORDER — check length BEFORE accessing currentLine
  if (lineIndex >= lines.length) {
    const cursorLine = document.createElement("div");
    cursorLine.className = "terminal-line";
    cursorLine.innerHTML = '<span class="fake-cursor">_</span>';
    cursorLine.style.visibility = "visible";
    document.getElementById("terminal").appendChild(cursorLine);

    setTimeout(() => {
      cursorLine.remove();
      clearTerminal(() => {
        typeAsciiArt(asciiArt, 'ascii-container', () => {
          const cmd = document.getElementById('command-line');
          const opts = document.getElementById('options-line');
          cmd.style.visibility = opts.style.visibility = "visible";
          cmd.classList.add('fade-in');
          opts.classList.add('fade-in');
          animateAscii('ascii-container');
          explodeAscii('ascii-container');
          setTimeout(showBlogPopupIfRecent, 3000);
        });
      });
    }, 2000);
    return;
  }

  // Safe now to access currentLine
  const currentLine = lines[lineIndex];
  const text = currentLine?.dataset.text;

  if (!text) {
    currentLine.style.visibility = "visible";
    currentLine.classList.add("fade-in");
    lineIndex++;
    setTimeout(showTerminalLines, 300);
    return;
  }

  typeLine(currentLine, text, () => {
    lineIndex++;
    setTimeout(showTerminalLines, 300);
  });
}



  function clearTerminal(callback) {
    const terminal = document.getElementById("terminal");
    terminal.innerHTML = '';

    const asciiPhase = document.createElement("div");
    asciiPhase.id = "ascii-phase";
    asciiPhase.style.display = "block";

    const commandLine = document.createElement("div");
    commandLine.className = "terminal-line";
    commandLine.id = "command-line";
    commandLine.style.visibility = "hidden";
    commandLine.textContent = "> enter command:";

    const optionsLine = document.createElement("div");
    optionsLine.className = "terminal-line";
    optionsLine.id = "options-line";
    optionsLine.style.visibility = "hidden";
    optionsLine.innerHTML = `
      <span class="terminal-option" id="link-projects">[projects]</span>
      <span class="terminal-separator">|</span>
      <span class="terminal-option" id="link-store">[store]</span>
      <span class="fake-cursor" id="cursor">_</span>
    `;

    const spacer = document.createElement("br");
    const asciiContainer = document.createElement("div");
    asciiContainer.id = "ascii-container";

    asciiPhase.appendChild(commandLine);
    asciiPhase.appendChild(optionsLine);
    asciiPhase.appendChild(spacer);
    asciiPhase.appendChild(asciiContainer);
    terminal.appendChild(asciiPhase);

    setTimeout(() => {
      document.getElementById("link-projects").addEventListener("click", () => navigateWithDelay("/pages/projects"));
      document.getElementById("link-store").addEventListener("click", () => navigateWithDelay("/pages/store"));
    }, 10);

    callback();
  }

  function typeAsciiArt(lines, containerId, callback) {
    const container = document.getElementById(containerId);
    if (!container) return;

    let index = 0;
    function next() {
      if (index >= lines.length) {
        if (callback) callback();
        return;
      }

      const line = document.createElement("div");
      line.className = "terminal-line";
      line.style.visibility = "visible";
      line.textContent = lines[index];
      line.dataset.original = lines[index];
      container.appendChild(line);
      index++;
      setTimeout(next, 1);
    }

    next();
  }

  function animateAscii(containerId) {
    const container = document.getElementById(containerId);
    const glyphs = "AaÀàÁáÂâÄäǍǎÃãÅåĀāBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz%$#@!*+=<>";

    setInterval(() => {
      container.querySelectorAll(".terminal-line").forEach(line => {
        const updated = [...line.textContent].map(char =>
          Math.random() < 0.03 && char !== " " ? glyphs[Math.floor(Math.random() * glyphs.length)] : char
        );
        line.textContent = updated.join("");
      });
    }, 50);
  }

function explodeAscii(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.addEventListener("pointerdown", (e) => {
    e.preventDefault();

    const x = e.pageX;
    const y = e.pageY;
    const blastRadius = 100;
    const glitchSteps = ["▓", "▒", "░", " "];
    const regenGlitches = ["▓", "▒", "░", ".", ":", ""];

    // Play sound
    const audio = new Audio('https://cdn.shopify.com/s/files/1/0612/2602/5027/files/explo.mp3?v=1744885032');
    audio.volume = 0.2;
    audio.play();

    const terminal = document.getElementById("terminal");
    terminal.classList.add("shake");
    setTimeout(() => terminal.classList.remove("shake"), 200);

    const lines = container.querySelectorAll(".terminal-line");

    lines.forEach((line) => {
      const original = line.dataset.original || line.textContent;
      line.dataset.original = original;

      const textNode = line.childNodes[0];
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;

      const chars = original.split("");

      chars.forEach((char, j) => {
        const range = document.createRange();
        try {
          range.setStart(textNode, j);
          range.setEnd(textNode, j + 1);
        } catch (err) {
          return;
        }

        const rect = range.getBoundingClientRect();
        const charCenterX = rect.left + rect.width / 2 + window.scrollX;
        const charCenterY = rect.top + rect.height / 2 + window.scrollY;
        const dx = charCenterX - x;
        const dy = charCenterY - y;

        // 🎯 Rough radius by adding randomness
        const dist = Math.sqrt(dx * dx + dy * dy) - Math.random() * 20;

        if (dist < blastRadius && char !== " ") {
          // ⛓️ Crumble effect
          glitchSteps.forEach((glitchChar, step) => {
            setTimeout(() => {
              const currentText = line.textContent.split('');
              currentText[j] = glitchChar;
              line.textContent = currentText.join('');
            }, step * 100 + j * 5);
          });

          // ♻️ Imperfect regeneration
          setTimeout(() => {
            const currentText = line.textContent.split('');
            currentText[j] = regenGlitches[Math.floor(Math.random() * regenGlitches.length)];
            line.textContent = currentText.join('');
          }, 700 + j * 10 + Math.random() * 500);
        }
      });
    });
    // 🐦 Spawn bird
    spawnBird();
  });
}


  function spawnBird() {
    if (birdSpawned) return;
    birdSpawned = true;

    const bird = document.createElement("pre");
    bird.className = "ascii-bird";
    const frames = [
      "    ___(  v)> \n     \\___)    ",
      "    ___( - )> \n    \\____)    ",
      "    ___( ^ )> \n     \\___)    "
    ];

    let frameIndex = 0;
    const flapInterval = setInterval(() => {
      bird.innerText = frames[frameIndex];
      frameIndex = (frameIndex + 1) % frames.length;
    }, 200);

    document.body.appendChild(bird);

    bird.addEventListener("click", () => {
      clearInterval(flapInterval);

      const rect = bird.getBoundingClientRect();
      const x = rect.left + rect.width / 2 + window.scrollX;
      const y = rect.top + rect.height / 2 + window.scrollY;

      const sound = explosionSound.cloneNode();
      sound.play();

      setTimeout(() => {
        const pop = new Audio('https://cdn.shopify.com/s/files/1/0612/2602/5027/files/chicken_panic.mp3?v=1744969529');
        pop.volume = 0.2;
        pop.play();
      }, 150);

      explodeBird(x, y);
      bird.remove();
      showEmailPrompt();
    });
  }

  function explodeBird(x, y) {
    const pieces = ['\\', '_', 'o', '/', '<', '^', '~'];
    for (let i = 0; i < 7; i++) {
      const char = pieces[Math.floor(Math.random() * pieces.length)];
      const piece = document.createElement("span");
      piece.textContent = char;
      Object.assign(piece.style, {
        position: "absolute",
        left: `${x}px`,
        top: `${y}px`,
        color: "#00ff00",
        fontFamily: "Courier New, monospace",
        fontSize: "16px",
        zIndex: "999",
        pointerEvents: "none",
        transition: "transform 0.6s ease-out, opacity 0.6s ease-out"
      });
      document.body.appendChild(piece);

      const angle = Math.random() * 2 * Math.PI;
      const distance = 50 + Math.random() * 50;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance;

      requestAnimationFrame(() => {
        piece.style.transform = `translate(${dx}px, ${dy}px) rotate(${Math.random() * 720 - 360}deg)`;
        piece.style.opacity = "0";
      });

      setTimeout(() => piece.remove(), 700);
    }
  }

  function showEmailPrompt() {
    const wrapper = document.getElementById("newsletter-wrapper");
    const form = document.getElementById("newsletter-form");
    if (!wrapper || !form) return;

    wrapper.style.display = "block";
    const lines = wrapper.querySelectorAll(".terminal-line");
    let i = 0;

    function typeNextLine() {
      if (i >= lines.length) {
        form.style.display = "block";
        form.scrollIntoView({ behavior: "smooth" });
        return;
      }

      const line = lines[i];
      const text = line.dataset.text;
      typeLine(line, text, () => {
        i++;
        setTimeout(typeNextLine, 300);
      });
    }

    typeNextLine();
  }

  function navigateWithDelay(url) {
    const terminal = document.getElementById("terminal");
    const navLine = document.createElement("div");
    navLine.className = "terminal-line fade-in";
    navLine.style.visibility = "visible";
    navLine.textContent = `> navigating to ${url.includes("store") ? "store" : "projects"}...`;
    terminal.appendChild(navLine);
    setTimeout(() => window.location.href = url, 1000);
  }

  function showBlogPopupIfRecent() {
    const popup = document.getElementById("blog-popup");
    if (!popup) return;
    const publishedDate = new Date(popup.dataset.published);
    const now = new Date();
    const diffDays = (now - publishedDate) / (1000 * 60 * 60 * 24);
    if (diffDays <= 7) popup.style.display = "block";
  }

  showTerminalLines();
};
